/**
 * <maliki-tabbar>: the app-style bottom bar on phones and tablets.
 * Mirrors the header cart count (the header's "cart-count" partial is re-rendered after every cart change)
 * into the bar's Sacola badge, and hides the bar while the on-screen keyboard is open.
 */
class MalikiTabbar extends HTMLElement {
  connectedCallback() {
    this.badge = this.querySelector('[data-tabbar-count]');
    this.header = document.querySelector('[data-header-nav-group]');
    this.sync = this.sync.bind(this);
    if (this.header) {
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.header, { childList: true, subtree: true });
    }
    this.onFocusIn = (event) => {
      if (event.target.matches('input:not([type="checkbox"]):not([type="radio"]):not([type="submit"]), textarea, select')) this.toggleAttribute('data-keyboard', true);
    };
    this.onFocusOut = () => this.removeAttribute('data-keyboard');
    document.addEventListener('focusin', this.onFocusIn);
    document.addEventListener('focusout', this.onFocusOut);
    this.sync();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    document.removeEventListener('focusin', this.onFocusIn);
    document.removeEventListener('focusout', this.onFocusOut);
  }

  sync() {
    if (!this.badge || !this.header) return;
    const source = this.header.querySelector('#header-cart-trigger [aria-hidden="true"] > span');
    const count = source ? source.textContent.trim() : '';
    const changed = this.badge.textContent.trim() !== count;
    this.badge.textContent = count;
    this.badge.hidden = count === '' || count === '0';
    // Short "pop" on the badge when the cart changes (CSS in snippets/maliki-mobile-styles).
    if (changed && this.ready && !this.badge.hidden) {
      this.badge.removeAttribute('data-bump');
      void this.badge.offsetWidth;
      this.badge.setAttribute('data-bump', '');
    }
    this.ready = true;
  }
}

if (!customElements.get('maliki-tabbar')) customElements.define('maliki-tabbar', MalikiTabbar);
